import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, asapScheduler, observeOn } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubjectsService {
  templatesFocusOutEditor$ = new BehaviorSubject<void | null>(null);
  templatesFocusOutEditorWithObserveOn$ = this.templatesFocusOutEditor$.pipe(observeOn(asapScheduler));
  closeScheduleCellDialog$ = new Subject<void>();
  errScheduleCellDialog$ = new Subject<void>();
}
